<template>
    <BaseModal size="md" v-model="showReportModal" :noPadding="true" @onClose="closeModal">
        <template v-slot:header>
            <div class="d-flex justify-content-between px-4 py-3">
                <h3 v-if="reportTypePhoto" class="t-heavy mb-0">Report error:call:43's Photograph</h3>
                <h3 v-else class="t-heavy mb-0">Report error:call:44's Profile</h3>
                <BaseButton
                    :filled="true"
                    border="round"
                    color="black"
                    @click="closeModal"
                >
                    <IconClose />
                </BaseButton>
            </div>
            <hr class="m-0" />
        </template>
        <template v-slot:body v-if="!reportProfileSubmitted" style="height: auto">
            <BaseLineBox label="Reason for reporting" class="m-4">
                <BaseBoxSelect
                    :items="reportReasonsList"
                    v-model="reportReason"
                    class="p-4 flex-column align-content-center"
                />
            </BaseLineBox>
            <p class="aup-input-error t-micro text-danger mt-1 mb-0 px-4" v-if="reportReasonError">error:call:45</p>
            <BaseTextArea
                class="m-4 d-flex flex-column"
                v-model="reportMessage"
                :label="messageLabel"
                :maxLength="500"
                :error="reportMessageError"
            />
            <div class="d-flex m-4">
                <BaseButton
                    class="mt-2"
                    @click="handleReportSubmit"
                >Report</BaseButton>
                <BaseButton
                    class="mt-2 ml-2"
                    @click="closeModal"
                    :filled="false"
                    color="black"
                    border="thin"
                >Cancel</BaseButton>
            </div>
        </template>
		<template v-slot:body v-else-if="reportFormError">
            <div class="d-flex flex-column p-5 h-100">
                <div class="d-flex flex-column justify-content-center" style="flex-grow: 1;">
                    <h3>There was an error in submitting.</h3>
                    <h5
                        class="t-regular"
                    >Please refresh the page and try again.</h5>
                </div>
                <div>
                    <BaseButton class @click="closeModal">Close</BaseButton>
                </div>
            </div>
        </template>
		<template v-slot:body v-else-if="reportFormErrorAlreadyReported">
            <div class="d-flex flex-column p-5 h-100">
                <div class="d-flex flex-column justify-content-center" style="flex-grow: 1;">
					<h3 v-if="reportTypePhoto" class="t-heavy mb-0">You have already reported this media.</h3>
                	<h3 v-else class="t-heavy mb-0">You have already reported this profile.</h3>
                    <h5
                        class="t-regular"
                    >Don't worry, we are reviewing and will take appropriate action.</h5>
                </div>
                <div>
                    <BaseButton class @click="closeModal">Close</BaseButton>
                </div>
            </div>
        </template>
        <template v-slot:body v-else-if="reportProfileSubmitted && !reportFormErrorAlreadyReported">
            <div class="d-flex flex-column p-5 h-100">
                <div class="d-flex flex-column justify-content-center" style="flex-grow: 1;">
                    <h3>Your report has been sent.</h3>
                    <h5
                        class="t-regular"
                    >Our content moderation team will review and take appropriate action.</h5>
                </div>
                <div>
                    <BaseButton class @click="closeModal">Close</BaseButton>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '@/components/global/BaseModal';
import BaseTextArea from '@/components/global/BaseTextArea';
import BaseBoxSelect from '@/components/global/BaseBoxSelect';

export default {
    name: 'BaseReportModal',
    components: {
        BaseModal,
        BaseTextArea,
        BaseBoxSelect,
    },
    props: {
        showReportModal: {
            type: Boolean,
            default: false,
		},
		reportTypePhoto: {
            type: Boolean,
            default: true,
        },
        reportReasonsList: {
            type: Array,
            default: () => [],
        },
        userName: {
            type: String,
            default: '',
		},
		reportItemGuid: {
			type: String,
			required: true,
		}
    },
    data() {
        return {
            reportMessage: '',
            reportReason: [],
			reportReasonError: '',
			reportMessageError: '',
			reportProfileSubmitted: false,
			reportFormErrorAlreadyReported: false,
			reportFormError: false,
        };
    },
    computed: {
        requiresMessage() {
            return this.reportReason.some(reason => reason.toLowerCase() === 'other');
        },
        messageLabel() {
            return this.requiresMessage ? 'Message to sony (required)' : 'Message to sony';
        },
    },
    watch: {
        reportReason(val) {
            if (val.length) {
                this.reportReasonError = '';
            }
            if (!val.some(reason => reason.toLowerCase() === 'other')) {
                this.reportMessageError = '';
            }
        },
        reportMessage(val) {
            if (val.trim()) {
                this.reportMessageError = '';
            }
        },
    },
    mounted() {},
    methods: {
		closeModal() {
			this.$emit('onClose')
		},
		validateReportForm() {
			if (!this.reportReason.length) {
				this.reportReasonError = 'Please select at least one reason for reporting.';
				return false;
			}
			this.reportReasonError = '';

			if (this.requiresMessage && !this.reportMessage.trim()) {
				this.reportMessageError = 'Please enter a message when selecting Other as a reason.';
				return false;
			}
			this.reportMessageError = '';
			return true;
		},
		handleReportSubmit() {
			if (!this.validateReportForm()) {
				return;
			}
			if (this.reportTypePhoto) {
				this.submitMediaReport(this.reportItemGuid);
			} else {
				this.submitProfileReport(this.reportItemGuid);
			}
		},
		submitMediaReport(reportItemGuid) {
			this.$store.dispatch('reportProfileOrImage', {
				"ppd_usermediaid": reportItemGuid,
				"ppd_reason": this.reportReason.join(','),
				"ppd_message": this.reportMessage,
			})
			.then((response) => this.reportProfileSubmitted = true )
			.catch(error => {
				// console.log(error.response.status)
				this.reportProfileSubmitted = true;
				if(error.response.status == '409') {
					this.reportFormErrorAlreadyReported = true;
				} else {
					this.reportFormError = true;
				}
			})
		},
		submitProfileReport(reportItemGuid) {
			this.$store.dispatch('reportProfileOrImage', {
				"ppd_publicprofileid": reportItemGuid,
				"ppd_reason": this.reportReason.join(','),
				"ppd_message": this.reportMessage,
			})
			.then((response) => this.reportProfileSubmitted = true )
			.catch(error => {
				// console.log(error.response.status)
				this.reportProfileSubmitted = true;
				if(error.response.status == '409') {
					this.reportFormErrorAlreadyReported = true;
				} else {
					this.reportFormError = true;
				}
			})

		},
    },
};
</script>

<style lang="scss">
@import '../../assets/scss/all.scss';
</style>

